import React from 'react'
import Moment from 'react-moment'
import NumberFormat from 'react-number-format'
import { Popup, Icon } from 'semantic-ui-react'

export const billingColumns = [
  {
    Header: 'Company',
    accessor: 'company',
    width: 100,
  },
  {
    Header: 'Vendor',
    accessor: 'vendor',
    width: 120,
  },
  {
    Header: 'Special credit term',
    accessor: 'specialCr',
    className:'center',
    width: 120,
    Cell: row => (row.value ? 'Yes' : 'No')
  },
  {
    Header: 'Scan QR date',
    accessor: 'scanQrDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'Doc No.',
    accessor: 'blDocNo',
    className:'center',
    width: 120,
  },
  {
    Header: 'Doc date',
    accessor: 'docDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'Currency',
    accessor: 'currency',
    className:'center',
    width: 120,
  },
  {
    Header: 'Invoice No.',
    accessor: 'invoiceNo',
    className:'center',
    width: 120,
  },
  {
    Header: 'Delivery Type',
    accessor: 'deliveryType',
    className:'center',
    width: 120,
  },
  {
    Header: 'Invoice Amount (Ex. VAT)',
    accessor: 'totalInvoiceAmount',
    className:'center',
    Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} fixedDecimalScale={true}/>),
    width: 120,
  },
  {
    Header: 'Deduct Down Payment/Advance Payment',
    accessor: 'deductDownPayment',
    className:'center',
    Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} fixedDecimalScale={true}/>),
    width: 120,
  },
  {
    Header: 'Invoice Amount (deduct Down Payment)(Inc. VAT)',
    accessor: 'invoiceAmt',
    className:'right',
    Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} fixedDecimalScale={true}/>),
    width: 120,
  },
  {
    Header: 'Deduct Retention/Warranty',
    accessor: 'deductRetentionAmount',
    className:'center',
    Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} fixedDecimalScale={true}/>),
    width: 120,
  },
  {
    Header: 'Net Amount after deduction (Ref. GR)',
    accessor: 'netAmountAfterDeduct',
    className:'right',
    Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} fixedDecimalScale={true}/>),
    width: 120,
  },
  {
    Header: 'Title',
    accessor: 'title',
    width: 120,
  },
  {
    Header: 'Status',
    accessor: 'status',
    className:'center',
    width: 120,
  },
  {
    Header: 'Activity',
    accessor: 'activity',
    width: 120,
  },
  {
    Header: 'GR EZP No.',
    accessor: 'grDocNo',
    className:'center',
    width: 120,
  },
  {
    Header: 'GR No.',
    accessor: 'sapGrNo',
    className:'center',
    width: 120,
  },
  {
    Header: 'LIV',
    accessor: 'mmInvoiceNumber',
    className:'center',
    width: 120,
  },
  {
    Header: 'FI Doc',
    accessor: 'fiInvoiceNumber',
    className:'center',
    width: 120,
  },
  {
    Header: 'Payt terms',    
    accessor: 'paymentTerm',
    className:'center',
    width: 120,
  },
  {
    Header: 'Estimate DueDate', 
    accessor: 'estimateDueDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'Payment Block',
    accessor: 'paymentBlock',
    className:'center',
    width: 120,
  },
  {
    Header: 'Payment No.',
    accessor: 'paymentNumber',
    className:'center',
    width: 120,
  },
  {
    Header: 'Due Date', 
    accessor: 'dueDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'PO No.',
    accessor: 'sapPoNo',
    Cell: row => (<Popup content={row.value} trigger={<div>{row.value}</div>} />),
    width: 120,
  },
  {
    Header: 'Requester',
    accessor: 'requester',
    width: 120,
  },
  {
    Header: 'Creator',
    accessor: 'creator',
    width: 120,
  },
  {
    Header: 'Created date',
    accessor: 'createdDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'Submitted date',
    accessor: 'submittedDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'Modified date',
    accessor: 'modifiedDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'Wating For Original Doc Date',
    accessor: 'waitforOriginalDocDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'Accept Date',
    accessor: 'acceptedDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'Complete Date',
    accessor: 'completedDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'Link',
    accessor: 'blId',
    className:'center',
    width: 50,
    Cell: row => (row.value ? <a onClick={()=>window.open(`http://ezprocure.dtgo.com/procurement/billform/${row.value}`)}>Link</a> : null)
  },
]

export const billingColumnCSV = [
  {
    label: 'Company',
    key: 'company',
  },
  {
    label: 'Vendor',
    key: 'vendor',
  },
  {
    label: 'Special credit term',
    key: 'specialCr',
  },
  {
    label: 'Scan QR date',
    key: 'scanQrDate',
  },
  {
    label: 'Doc No.',
    key: 'blDocNo',
  },
  {
    label: 'Doc date',
    key: 'docDate',
  },
  {
    label: 'Currency',
    key: 'currency',
  },
  {
    label: 'Invoice No.',
    key: 'invoiceNo',
  },
  {
    label: 'Delivery Type',
    key: 'deliveryType',
  },
  {
    label: 'Invoice Amount (Ex. VAT)',
    key: 'totalInvoiceAmount',
  },
  {
    label: 'Deduct Down Payment/Advance Payment',
    key: 'deductDownPayment',
  },
  {
    label: 'Invoice Amount (deduct Down Payment)(Inc. VAT)',
    key: 'invoiceAmt',
  },
  {
    label: 'Deduct Retention/Warranty',
    key: 'deductRetentionAmount',
  },
  {
    label: 'Net Amount after deduction (Ref. GR)',
    key: 'netAmountAfterDeduct',
  },
  {
    label: 'Title',
    key: 'title',
  },
  {
    label: 'Status',
    key: 'status',
  },
  {
    label: 'Activity',
    key: 'activity',
  },
  {
    label: 'GR EZP No.',
    key: 'grDocNo',
  },
  {
    label: 'GR No.',
    key: 'sapGrNo',
  },
  {
    label: 'LIV',
    key: 'mmInvoiceNumber',
  },
  {
    label: 'FI Doc',
    key: 'fiInvoiceNumber',
  },
  {
    label: 'Payt terms',
    key: 'paymentTerm',
  },
  {
    label: 'Estimate DueDate',
    key: 'estimateDueDate',
  },
  {
    label: 'Payment Block',
    key: 'paymentBlock',
  },
  {
    label: 'Payment No.',
    key: 'paymentNumber',
  },
  {
    label: 'Due Date',
    key: 'dueDate',
  },
  {
    label: 'PO No.',
    key: 'sapPoNo',
  },
  {
    label: 'Payment Term PO',
    key: 'paymentCode',
  },
  {
    label: 'Requester',
    key: 'requester',
  },
  {
    label: 'Creator',
    key: 'creator',
  },
  {
    label: 'Created date',
    key: 'createdDate',
  },
  {
    label: 'Submitted date',
    key: 'submittedDate',
  },
  {
    label: 'Modified date',
    key: 'modifiedDate',
  },
  {
    label: 'Wating For Original Doc Date',
    key: 'waitforOriginalDocDate',
  },
  {
    label: 'Accept Date',
    key: 'acceptedDate',
  },
  {
    label: 'Complete date',
    key: 'completedDate',
  },
  {
    label: 'Link',
    key: 'blId',
  },
]

export const grColumns = [
  {
    Header: 'Company',
    accessor: 'company',
    width: 120,
  },
  {
    Header: 'ProjectName',
    accessor: 'projectName',
    width: 120,
  },
  {
    Header: 'GR No.',
    accessor: 'grDocNo',
    className:'center',
    width: 120,
  },
  {
    Header: 'Doc date',
    accessor: 'docDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'Posting date',
    accessor: 'posDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'PO No.',
    accessor: 'poNum',
    Cell: row => (<Popup content={row.value} trigger={<div>{row.value}</div>} />),
    width: 120,
  },
  {
    Header: 'Vendor',
    accessor: 'vendor',
    width: 120,
  },
  {
    Header: 'Special credit term',
    accessor: 'specialCr',
    className:'center',
    width: 120,
    Cell: row => {console.log(row.value);return(row.value ? 'Yes' : 'No')}
  },
  {
    Header: 'Currency',
    accessor: 'currency',
    className:'center',
    width: 120,
  },
  {
    Header: 'Invoice No.',
    accessor: 'invoiceNumber',
    className:'center',
    width: 120,
  },
  {
    Header: 'Invoice Amount (Excl. VAT)',
    accessor: 'invoiceAmt',
    className:'right',
    Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true}/>),
    width: 120,
  },
  {
    Header: 'Amount after deduc',
    accessor: 'amtAfterDeduc',
    className:'right',
    Cell: row => (<NumberFormat value={row.value} displayType={'text'} thousandSeparator={true}/>),
    width: 120,
  },
  {
    Header: 'Title',
    accessor: 'title',
    width: 120,
  },
  {
    Header: 'Status',
    accessor: 'status',
    className:'center',
    width: 120,
  },
  {
    Header: 'Activity',
    accessor: 'activity',
    width: 120,
  },
  {
    Header: 'Creator',
    accessor: 'creator',
    width: 120,
  },
  {
    Header: 'Requester',
    accessor: 'requester',
    width: 120,
  },
  {
    Header: 'Start By',
    accessor: 'startBy',
    width: 120,
  },
  {
    Header: 'Modified By',
    accessor: 'lastModifiedBy',
    width: 120,
  },
  {
    Header: 'Created date',
    accessor: 'createdDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'Modified date',
    accessor: 'modifiedDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'Link',
    accessor: 'grId',
    className:'center',
    width: 50,
    Cell: row => (row.value ? <a onClick={()=>window.open(`http://ezprocure.dtgo.com/procurement/goodsServiceReceipt/${row.value}`)}>Link</a> : null)
  },
]

export const grColumnCSV = [
  {
    label: 'Company',
    key: 'company',
  },
  {
    label: 'ProjectName',
    key: 'projectName',
  },
  {
    label: 'GR No.',
    key: 'grDocNo',
  },
  {
    label: 'Doc date',
    key: 'docDate',
  },
  {
    label: 'Posting date',
    key: 'posDate',
  },
  {
    label: 'PO No.',
    key: 'poNum',
  },
  {
    label: 'Vendor',
    key: 'vendor',
  },
  {
    label: 'Special credit term',
    key: 'specialCr',
  },
  {
    label: 'Currency',
    key: 'currency',
  },
  {
    label: 'Invoice No.',
    key: 'invoiceNumber',
  },
  {
    label: 'Invoice Amount (Excl. VAT)',
    key: 'invoiceAmt',
  },
  {
    label: 'Amount after deduc',
    key: 'amtAfterDeduc',
  },
  {
    label: 'Title',
    key: 'title',
  },
  {
    label: 'Status',
    key: 'status',
  },
  {
    label: 'Activity',
    key: 'activity',
  },
  {
    label: 'Creator',
    key: 'creator',
  },
  {
    label: 'Requester',
    key: 'requester',
  },
  {
    label: 'Start By',
    key: 'startBy',
  },
  {
    label: 'Created date',
    key: 'createdDate',
  },
  {
    label: 'Modified By',
    key: 'lastModifiedBy',
  },
  {
    label: 'Modified date',
    key: 'modifiedDate',
  },
  {
    label: 'Link',
    key: 'grId',
  },
]

export const roleColumns = [
  {
    Header: 'Name',
    accessor: 'fullName',
  },
  {
    Header: 'Active',
    accessor: 'active',
    className:'center',
    width: 120,
    Cell: row => (<Icon name={row.value?'check circle':'remove circle'} color={row.value?'green':'red'}/>)
  },
  {
    Header: 'Admin',
    accessor: 'isAdmin',
    className:'center',
    width: 120,
    Cell: row => (<Icon name={row.value?'check circle':'remove circle'} color={row.value?'green':'red'}/>)
  },
  {
    Header: 'Created By',
    accessor: 'createdByName',
    width: 120,
  },
  {
    Header: 'Created date',
    accessor: 'createdDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
  {
    Header: 'Modified By',
    accessor: 'modifiedByName',
    width: 120,
  },
  {
    Header: 'Modified date',
    accessor: 'modifiedDate',
    className:'center',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY'>{row.value}</Moment> : null)
  },
]
